import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-activation-failure',
    standalone: true,
    imports: [RouterModule],
    templateUrl: './activation-failure.component.html',
    styleUrl: './activation-failure.component.scss'
})
export class ActivationFailureComponent {

}
